import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslocoDirective } from '@jsverse/transloco';

import { ChrComponentsModule } from '@ciphr-design-system/angular';

import { TooltipDirective } from '@ciphr/shared/popover';

import { CollectionFilterDirective } from '../collection-filter.directive';
import { CollectionFilterValue } from '../../../../models/collection-filter-value.type';
import { CollectionFilterHeaderComponent } from '../collection-filter-header.component';

@Component({
  selector: 'ciphr-dictionary-collection-filter',
  standalone: true,
  imports: [
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    FormsModule,
    TranslocoDirective,
    ChrComponentsModule,
    CollectionFilterHeaderComponent,
    TooltipDirective,
  ],
  templateUrl: './dictionary-collection-filter.component.html',
  styleUrl: './dictionary-collection-filter.component.scss',
})
export class DictionaryCollectionFilterComponent {
  private readonly collectionFilterDirective = inject(CollectionFilterDirective);

  private readonly searchValue = signal<string>('');
  readonly expanded = this.collectionFilterDirective.expanded;
  readonly filter = this.collectionFilterDirective.filter;
  readonly filterValues = computed(() => this.getFilterValues());
  readonly selectedValues = this.collectionFilterDirective.selectedValues;

  search({ target }: Event): void {
    this.searchValue.set((target as HTMLInputElement).value);
  }

  toggleValueSelection(value: CollectionFilterValue['value']): void {
    this.collectionFilterDirective.toggleValueSelection(value);
  }

  private getFilterValues(): CollectionFilterValue[] {
    const searchValue = this.searchValue();
    const { values } = this.filter();

    return (searchValue && values.filter((value) => value.label.toLowerCase().includes(searchValue.toLowerCase()))) || values;
  }
}
